
import { CONSTANTS } from '../constants';

export default{
    name: 'Showcase',
    data:()=>({
        PRODUCTS : CONSTANTS.PRODUCTS,
    })
}
